<template>

  <b-card
    class="mb-1"
    style="margin:0;border:1px solid #c9c9c9;"
  >
    <b-card-header
      header-tag="header" 
      role="tab"
      block 
      @click="visibleBody = !visibleBody"
      style="padding:0; cursor: pointer;"
    >
      <span class="mr-5">POSTNATALES</span>
      <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
    </b-card-header>
    <b-collapse 
      v-model="visibleBody" 
      id="collapse-4"
    >
      <b-card-body >

        <fieldset :disabled="onlyView">

          <b-row class="d-flex align-items-center">
            <label class="col-3"> Lactancia materna: </label>
            <v-select
              class="col-4"
              placeholder="Seleccione una o mas opciones"
              :options="lactanciaOpts"
              :reduce="option => option"
              label="text"
              v-model="postnatal.lactancia.selected"
              :disabled="onlyView"
            />


            <div v-if="postnatal.lactancia.selected && postnatal.lactancia.selected === 'Mixta'" class="col-12 my-1">

              <label for="">Alimentacion complementaria</label>
              <b-form-input 
                
                v-model="postnatal.lactancia.descripcion"
                rows="1"
              />
            </div>
          </b-row>



          <b-row class="my-2 d-flex align-items-center">
            <label class="col-12"> Inmunizaciones: </label>

            <b-form-checkbox 
              switch
              v-model="postnatal.inmunizaciones.completas"
              class="col-3 ml-2"
            >
              {{ postnatal.inmunizaciones.completas ? 'Completas' : 'Incompletas' }}
            </b-form-checkbox>

            <b-form-input
              v-model="postnatal.inmunizaciones.descripcion"
              class="col-7"
              rows="1"
              placeholder="Describa..."
            />

          </b-row>

          <b-row class="my-2 d-flex align-items-center">
            <label class="col-12"> Reacción postvacunal : </label>

            <v-select
              class="col-4"
              placeholder="Seleccione una o mas opciones"
              :options="['si', 'no', 'no recuerda']"
              v-model="postnatal.reacciones.selected"
              :disabled="onlyView"
            />

            <b-form-input
              v-if="postnatal.reacciones.selected"
              v-model="postnatal.reacciones.descripcion"
              class="col-7"
              rows="1"
              placeholder="Describa..."
            />

            
          </b-row>


          <b-row class="my-2 d-flex align-items-center">
            <label class="col-12"> Tamizaje Metabolico: </label>

            <b-form-checkbox 
              switch
              v-model="postnatal.tamizaje.active"
              class="col-3 ml-2"
            >
              {{ postnatal.tamizaje.active ? 'Si' : 'No' }}
            </b-form-checkbox>

            <b-form-input
              v-if="postnatal.tamizaje.active"
              v-model="postnatal.tamizaje.descripcion"
              class="col-7"
              rows="1"
              placeholder="Describa..."
            />

          </b-row>


          <b-row class="my-2 d-flex align-items-center">
            <label class="col-12"> Hospitalizaciones previas: </label>

            <b-form-checkbox 
              switch
              v-model="postnatal.hospitalizaciones.active"
              class="col-3 ml-2"
            >
              {{ postnatal.hospitalizaciones.active ? 'Si' : 'No' }}
            </b-form-checkbox>

            <b-form-input
              v-if="postnatal.hospitalizaciones.active"
              v-model="postnatal.hospitalizaciones.descripcion"
              class="col-7"
              rows="1"
              placeholder="Describa..."
            />

          </b-row>

          
          <!-- <b-card 
            border-variant="light"
            class="denticion"
          >
            <h6> Dentición: </h6>

            <b-row class="my-2">

              <b-col>
                <label> Superiores: </label>

                <b-form-checkbox-group
                  v-model="denticion.superior"
                  :options="dientesSupOpts"
                />
              </b-col>

              <b-col>
                <label> Inferiores: </label>

                <b-form-checkbox-group
                  v-model="denticion.inferior"
                  :options="dientesInfOpts"
                />
              </b-col>
            </b-row>
          </b-card> -->


          <b-row class="my-2">
            <label class="col-12">Procesos respiratorios: </label>
            <v-select
              v-model="postnatal.respiratorios.selected"
              class="col-4"
              placeholder="Seleccione una o mas opciones"
              :options="respiratoriosOpts"
              :reduce="option => option"
              label="text"
              :disabled="onlyView"
            />

            <b-form-input
              v-if="postnatal.respiratorios.selected && postnatal.respiratorios.selected.value !== 'ninguno'"
              v-model="postnatal.respiratorios.descripcion"
              class="col-8"
              placeholder="Describa..."
            />
          </b-row>

          <b-row class="my-2 d-flex align-items-center">
            <label class="col-12">Otras enfermedades: </label>
            <v-select
              v-model="postnatal.otrasEnfermedades"
              class="col-10"
              placeholder="Seleccione una o mas opciones"
              :options="otrasEnfermedadesOpts"
              :reduce="option => option"
              label="text"
              :multiple="true"
              taggable
              :disabled="onlyView"
            />

          </b-row>

          <b-row class="my-2 d-flex align-items-center">
            <label class="col-3">Intoxicaciones: </label>

            <b-form-checkbox
              v-model="postnatal.intoxicaciones.active"
              class="col-2 ml-2"
              switch
            >{{ postnatal.intoxicaciones.active ? 'Si' : 'No'}}</b-form-checkbox>
            
            <b-form-input
              v-if="postnatal.intoxicaciones.active"
              v-model="postnatal.intoxicaciones.descripcion"
              class="col"
              placeholder="Describa..."
            />
          </b-row>


          <b-row class="my-2 d-flex align-items-center">
            <label class="col-3">Transfunciones: </label>

            <b-form-checkbox
              class="col-2 ml-2"
              v-model="postnatal.transfunciones.active"
              switch
            >
              {{ postnatal.transfunciones.active ? 'Si' : 'No'}}
            </b-form-checkbox>
            
            <b-form-input
              v-if="postnatal.transfunciones.active"
              v-model="postnatal.transfunciones.descripcion"
              class="col"
              placeholder="Describa..."
            />
          </b-row>

          <b-row class="my-2 d-flex align-items-center">
            <label class="col-3">Alergias: </label>

            <b-form-checkbox
              class="col-2 ml-2"
              v-model="postnatal.alergias.active"
              switch
            >
              {{ postnatal.alergiasActive ? 'Si' : 'No'}}
            </b-form-checkbox>
            
            <b-form-input
              v-if="postnatal.alergias.active"
              v-model="postnatal.alergias.descripcion"
              class="col"
              placeholder="Describa..."
            />
          </b-row>

          <b-row class="my-2 d-flex align-items-center">
            <label class="col-3">Accidentes: </label>

            <b-form-checkbox
              class="col-2 ml-2"
              v-model="postnatal.accidentes.active"
              switch
            >
              {{ postnatal.accidentes.active ? 'Si' : 'No'}}
            </b-form-checkbox>
            
            <b-form-input
              v-if="postnatal.accidentes.active"
              v-model="postnatal.accidentes.descripcion"
              class="col"
              placeholder="Describa..."
            />
          </b-row>

          <b-row class="my-2 d-flex align-items-center">
            <label class="col-3">Quirurgicos: </label>

            <b-form-checkbox
              class="col-2 ml-2"
              v-model="postnatal.quirurgicos.active"
              switch
            >
              {{ postnatal.quirurgicos.active ? 'Si' : 'No'}}
            </b-form-checkbox>
            
            <b-form-input
              v-if="postnatal.quirurgicos.active"
              v-model="postnatal.quirurgicos.descripcion"
              class="col"
              placeholder="Describa..."
            />
          </b-row>


          <hr>

          <div class="my-3">
            
            <h6>Desarrollo psicomotriz</h6>

            <b-row>

              <b-col class="col-6">

                <b-row class="my-1 ml-1">
                  <label class="col-6"> Sostuvo la cabeza: </label>
                  <b-form-checkbox 
                    switch 
                    v-model="postnatal.psicoCabeza"
                  >
                    {{ postnatal.psicoCabeza ? 'Si' : 'No' }}
                  </b-form-checkbox>
                  
                </b-row>

                <b-row class="my-1 ml-1">
                  <label class="col-6"> Se sentó sólo/a: </label>
                  <b-form-checkbox 
                    switch 
                    v-model="postnatal.psicoSentarse"
                  >
                    {{ postnatal.psicoSentarse ? 'Si' : 'No' }}
                  </b-form-checkbox>
                  
                </b-row>
              </b-col>
              <b-col>
                <b-row class="my-1 ml-1">
                  <label class="col-6">Comunicación:</label>
                  <b-form-checkbox 
                    switch 
                    v-model="postnatal.psicoComunicacion"
                  >
                    {{ postnatal.psicoComunicacion ? 'Si' : 'No' }}
                  </b-form-checkbox>
                  
                </b-row>

                <b-row class="my-1 ml-1">
                  <label class="col-6">Caminó sólo/a:</label>
                  <b-form-checkbox 
                    switch 
                    v-model="postnatal.psicoCaminar"
                  >
                    {{ postnatal.psicoCaminar ? 'Si' : 'No' }}
                  </b-form-checkbox>
                  
                </b-row>
              </b-col>
            </b-row> 

          </div>

        </fieldset>

        
      </b-card-body>
    </b-collapse>

  </b-card>

</template>

<script>
import { mapState } from 'vuex';
import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {

  name: 'Postnatales',

  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    vSelect
  },

  data() {
    return {
      
      visibleBody: false,

      postnatal:{
        lactancia:{
          selected: null,
          descripcion: ''
        },

        inmunizaciones:{
          completas:false,
          descripcion:'',
        },

        tamizaje:{
          active:false,
          descripcion:'',
        },

        hospitalizaciones:{
          active:false,
          descripcion:'',
        },

        reacciones:{
          selected:null,
          descripcion:'',
        },

        respiratorios:{
          selected:null,
          descripcion:''
        },

        otrasEnfermedades:[],

        intoxicaciones:{
          active:false,
          descripcion:'',
        },

        transfunciones:{
          active:false,
          descripcion:'',
        },

        alergias:{
          active:false,
          descripcion:'',
        },

        accidentes:{
          active:false,
          descripcion:'',
        },

        quirurgicos:{
          active:false,
          descripcion:'',
        },


        psicoCabeza  : false,
        psicoSentarse: false,
        psicoComunicacion: false,
        psicoCaminar :false
      },


      // lactanciaOpts:[
      //   { value: 'no',        text: 'No' },
      //   { value: 'exclusiva', text: 'Exclusiva' },
      //   { value: 'mixta',     text: 'Mixta' }
      // ],

      lactanciaOpts:['No', 'Exclusiva', 'Mixta'],

      dientesSupOpts: [
        { value: 'incisisivo_central',  text: 'Incisivo central' },
        { value: 'incisisivo_lateral',  text: 'Incisivo lateral' },
        { value: 'colmillo',            text: 'Colmillo' },
        { value: 'primer_molar',        text: 'Primer molar' },
        { value: 'segundo_molar',       text: 'Segundo molar' },
      ],
      dientesInfOpts: [
        { value: 'segundo_molar',  text: 'Segundo molar' },
        { value: 'primer_molar',   text: 'Primer molar' },
        { value: 'colmillo',       text: 'Colmillo' },
        { value: 'incisisivo_central',  text: 'Incisivo central' },
        { value: 'incisisivo_lateral',  text: 'Incisivo lateral' },
      ],

      respiratoriosOpts:['Ninguno', 'Viral', 'Bacteriano'],

      otrasEnfermedadesOpts:[
        'Sindrome Down', 
        'Epilecsia', 
        'Conjuntivitis', 
        'TEA', 
        'Ictericia', 
        'Rubeola'
      ]
    }
  },

  methods: {
    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },


    resetPostnatal(){
      this.postnatal = {
        lactancia:{
          selected: null,
          descripcion: ''
        },

        inmunizaciones:{
          completas:false,
          descripcion:'',
        },

        tamizaje:{
          active:false,
          descripcion:'',
        },

        hospitalizaciones:{
          active:false,
          descripcion:'',
        },

        reacciones:{
          selected:null,
          descripcion:'',
        },

        respiratorios:{
          selected:null,
          descripcion:''
        },

        otrasEnfermedades:[],

        intoxicaciones:{
          active:false,
          descripcion:'',
        },

        transfunciones:{
          active:false,
          descripcion:'',
        },

        alergias:{
          active:false,
          descripcion:'',
        },

        accidentes:{
          active:false,
          descripcion:'',
        },

        quirurgicos:{
          active:false,
          descripcion:'',
        },

      }
    },


    completarCampos(data){
      if(!data) return null;

      const objCopy = { ...data };

      if(!objCopy.lactancia){
        objCopy.lactancia = {
          selected: null,
          descripcion: ''
        };
      }

      return objCopy
    }
  },


  computed: {
    ...mapState({
      stSemPediatrica: state => state.atencionCita.semiologias?.semPediatrica,
      stSemiologiaView: state => state.atencionMedica.dataAtencion.semiologiaView
    }),
  },


  watch: {
    
    stSemPediatrica:{
      immediate: true,
      deep: true,
      
      handler(newValue){
        if(this.onlyView) return;
        
        // const tokenAtencion = this.$route.params.token;
        // if(!tokenAtencion ) return;

        if (newValue.postnatal){
          this.postnatal = newValue.postnatal
        }
      }
    },

    stSemiologiaView:{
      immediate: true,
      handler(newValue){
        if(!this.onlyView) return;

        this.resetPostnatal();
        if (newValue?.postnatal) this.postnatal = newValue.postnatal
      }
    },

    postnatal:{
      deep:true,
      handler(newValue){
        if(this.onlyView) return;
        this.$store.commit("setPostNatales", newValue)
      }
    }
  }

}
</script>

<style>
  .denticion .custom-checkbox {
    width: 100%;
  }
</style>